const data = [{
  title: `什么是开放平台？`,
  id: 0,
  question:'什么是开放平台？',
  answer: `
开放平台，是整个集团与行业合作过程中，服务开放的必经之路，承担聚合内部服务，对行业开放和聚合行业服务，对内部开放 两部分核心责任，是集团赋能行业的重要枢纽。`,
  type: '2,0'
},{
  title: `错误码表`,
  id: 12,
  question:'错误码表',
  answer: `
  | **HTTP码** | **API码** | **描述** | **常见解决方案** |
  | :---: | :---: | :---: | :---: |
  | 400 | 40000001 | BusinessError | 错误原因：业务接口的内部错误<br />解决方案：<br />1.业务方自行检查接口日志和代码<br />2.若提示返回为null，业务方检查返回给开放平台的数据格式，目前只支持对象和数组 |
  | 400 | 40000001 | Error: no valid node in service | 错误原因：找不到内部业务接口的dubbo服务,<br />解决方案：<br />1. 业务方自行检查dubbo服务是否已部署，部署的dubbo 服务信息是否与真实服务器上一致<br />2. dubbo admin上是否有不可调用的机器<br />3. 联系开方平台同学一起处理 |
  | 400 | 40000001 | Error: not found method **  for service *** | 错误原因：dubbo接口没有对应的方法,<br />解决方案：<br />1.自行在 dubbo amdin上查看是否缺失此method<br />2.联系此 dubbo 接口的业务方排查<br />3.联系开方平台同学一起处理 |
  | 400 | 40000001 | Error: parse dubbo response error | 错误原因：dubbo接口返回null,<br />解决方案：<br />1.请结合ssmt排查，请求入参的格式是否正确，接口是否能正常返回值<br />2.检查dubbo接口返回的格式是否符合开放平台的出参要求，详看 [出参文档](https://souche.yuque.com/koumakan/mwnwir/goc0vd)<br />3.联系开方平台同学一起处理 |
  | 401 | 40100001 | lack of sign or token | 错误原因：请求体缺少签名,<br />解决方案：<br />1. 在 post body中添加 "sign" 字段<br />2. 在 http headers 添加 "x-izayoi-sign" 字段 (适用于老版本开放平台) |
  | 401 | 40100002 | lack of timestamp | 错误原因：请求体缺少时间戳,<br />解决方案：<br />在 post body中添加 "timestamp" 字段 |
  | 401 | 40100003 | lack of appKey | 错误原因：请求体缺少appKey，<br />解决方案：<br />1. 首先确认是post请求，且 body是json格式<br />2. 在 post body中添加 "appKey" 字段' |
  | 401 | 40100004 | not partner | 错误原因：无法找到合作商,<br />解决方案：<br />1. 首先确认是appKey和appSecret都不为空<br />2. 检查appKey的正确性，是不是此环境的appKey |
  | 401 | 40100005 | sign expired | 错误原因：请求过期,<br />解决方案：<br />1. 超过5min的签名，都报请求过期<br />2. 请基于当前时间戳签名 并 重新发起请求<br />3. 若使用当前时间戳仍过期，请检查您的系统时间 |
  | 401 | 40100006 | sign invalid | 错误原因：验签失败,<br />解决方案：<br />1. 首先检查body的各字段是否正确，尤其要注意，data的值是json格式的字符串,<br />2. 检查验签步骤是否正确，详情见鉴权文档<br />3. 推荐使用搜车提供的 java SDK 来完成鉴权 |
  | 403 | 40300001 | ip permission denied | 错误原因：白名单限制,<br />解决方案：<br />1. 确认调用方的对外出口ip,不清楚的请咨询各运维,<br />2. 在开放平台控制台，提交白名单申请<br />3. 联系您的产品，由产品来完成白名单添加（若产品没有权限，请联系开放平台的同学来授权产品角色）<br />4.若您正在搜车控制台上调试预发环境，遇到白名单限制，请提交白名单申请 '118.31.51.154' 到对应应用 |
  | 403 | 40300002 | api permission denied | 错误原因：api组权限限制,<br />解决方案：<br />1. 在被调用应用的所授权的api组中，并不存在此api，需要将api所在的api组授权给该应用<br />2. 在开放平台控制台，提交业务关联申请，选择要调用的api组和要授权的应用<br />3. 联系您的产品，由产品来完成分组授权（若产品没有权限，请联系开放平台的同学来授权产品角色） |
  | 404 | 40400001 | api not exist | 错误原因: 访问接口不存在<br />解决方案：<br />1.请检查请求的接口是否 是此开放平台环境的<br />2.注册 接口 到开放平台    |
  | 429 | 42900001 | app traffic over-loading | 错误原因: 请求接口所属的应用流量超限<br />解决方案：<br />1.等待应用流量重置周期，流量重置后请求<br />2.联系该应用负责人，增加应用流量额度或紧急重置应用流量。 |
  | 429 |   42900002 | api traffic over-loading | 错误原因: 请求接口流量超限<br />解决方案：<br />1.等待该接口流量重置周期，流量重置后请求<br />2.联系该应用负责人，增加接口流量额度或紧急重置接口流量。 |
  | 500 | 50000001 | InternalServerError | 错误原因：开放平台内部错误,<br />解决方案：<br />请立即反馈给开放平台的同学 |
  | 502 | 无 |  Bad Gateway | 错误原因：开放平台服务不可用,<br />解决方案：<br />请立即反馈给开放平台的同学 或 运维 |
`,
  type: '1,2'
}
];
export default data
